import { MailRowDataPropertyGetter, type SortColumn, getSortByForTable } from "owa-mail-list-store";
import type GroupHeader from "../type/GroupHeader";
import { unknownSenderOrRecipient } from "owa-people-strings/lib/strings/unknownsenderorrecipient.locstring.json";
import loc from "owa-localize";
import { SenderGroupHeaderId } from "../type/GroupHeaderId";
import type { GroupHeaderId } from "../type/GroupHeaderId";
import type { LocalizedString } from "owa-localize";
import type { TableView } from "owa-mail-list-store";

/**
 * Get group header for row (for From or To sort)
 * @param rowKey rowKey for which we want to lookup time group header
 * @param tableView tableView
 * @return group header for this row
 */
export default function getGroupHeaderForSortByFromTo(rowKey: string, tableView: TableView): GroupHeader {
    // Fetch recipients if we're sorting by To, otherwise fetch senders if we're
    // sorting by From
    return getGroupHeaderForSendersOrRecipients(getSortByForTable(tableView).sortColumn === 9
        ? MailRowDataPropertyGetter.getUniqueRecipients(rowKey, tableView)
        : MailRowDataPropertyGetter.getUniqueSenders(rowKey, tableView));
}

/**
 * Get group header for row in a table sorted by sender that has no folder sort (e.g. search)
 * @param rowKey rowKey for which we want to lookup the sender group header
 * @param tableView tableView
 * @return group header for this row
 */
export function getGroupHeaderForSortBySender(rowKey: string, tableView: TableView): GroupHeader {
    return getGroupHeaderForSendersOrRecipients(MailRowDataPropertyGetter.getUniqueSenders(rowKey, tableView));
}

export function getGroupHeaderForSortByRecipient(rowKey: string, tableView: TableView): GroupHeader {
    return getGroupHeaderForSendersOrRecipients(MailRowDataPropertyGetter.getUniqueRecipients(rowKey, tableView));
}

function getGroupHeaderForSendersOrRecipients(uniqueSendersOrRecipients: string[]): GroupHeader {
    let headerTextValue = loc(unknownSenderOrRecipient);
    let headerIdValue: GroupHeaderId = SenderGroupHeaderId.Unknown;
    
    // A sender with an address but no display name comes through as [undefined].
    const firstName = uniqueSendersOrRecipients?.[0];
    if (firstName?.trim()) {
        headerTextValue = firstName as any as LocalizedString;
        headerIdValue = firstName;
    }
    
    return {
        headerText: () => headerTextValue,
        headerId: headerIdValue,
    };
}
